<template>
  <div class="smartnews-conversion-api-history-list">
    <el-table :data="conversionApiHistoryList" border>
      <el-table-column
        fixed
        label="API送信時間"
        min-width="160px"
        prop="sendDatetime"
      >
      </el-table-column>
      <el-table-column label="プログラム名" min-width="160px">
        <template slot-scope="scope">
          <span v-if="scope.row.reportData.tools02PromotionData !== null">{{
            scope.row.reportData.tools02PromotionData.promotionName
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="ピクセル名" min-width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.tools02TagData.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="ピクセルタグID" min-width="220px">
        <template slot-scope="scope">
          <span>{{ scope.row.pixelTagId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="ビジネスID" min-width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.businessId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="CVイベント" min-width="200px">
        <template slot-scope="scope">
          <span>{{ getEventLabel(scope.row.eventName) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="API送信結果" min-width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.eventReceived === true">成功</span>
          <span v-else>失敗</span>
        </template>
      </el-table-column>
      <el-table-column label="エラーコード" min-width="220px">
        <template slot-scope="scope">
          <span>{{ getErrorCode(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column width="500px" label="エラーメッセージ">
        <template slot-scope="scope">
          <el-input readonly v-model="scope.row.errorMessage">
            <el-button
              @click="g_copyText(scope.row.errorMessage)"
              slot="append"
              icon="el-icon-document-copy"
            ></el-button>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        min-width="200px"
        prop="eventDatetime"
        label="CV発生日時"
      >
      </el-table-column>
      <el-table-column min-width="120px" prop="value" label="報酬額">
      </el-table-column>
      <el-table-column min-width="200px" label="atid生成日時">
        <template slot-scope="scope">
          <span v-if="scope.row.reportData.formattedAdtasukaruIdCreatedAt === null">-</span>
          <span v-else>{{ scope.row.reportData.formattedAdtasukaruIdCreatedAt }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="300px" label="atid">
        <template slot-scope="scope">
          <el-input readonly :value="scope.row.adtasukaruId">
            <el-button
              @click="g_copyText(scope.row.adtasukaruId)"
              slot="append"
              icon="el-icon-document-copy"
            ></el-button>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column min-width="300px" label="click_id">
        <template slot-scope="scope">
          <el-input readonly :value="scope.row.clickId">
            <el-button
              @click="g_copyText(scope.row.clickId)"
              slot="append"
              icon="el-icon-document-copy"
            ></el-button>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column min-width="300px" label="User Agent">
        <template slot-scope="scope">
          <el-input readonly v-model="scope.row.clientUserAgent">
            <el-button
              @click="g_copyText(scope.row.clientUserAgent)"
              slot="append"
              icon="el-icon-document-copy"
            ></el-button>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column min-width="160px" prop="clientIpAddress" label="IPアドレス">
      </el-table-column>
      <el-table-column min-width="200px" prop="eventSourceUrl" label="CVページURL">
      </el-table-column>
      <!-- SmartNews Ads への問い合わせに使う -->
      <el-table-column min-width="320px" label="request_id">
        <template slot-scope="scope">
          <el-input readonly :value="scope.row.requestId">
            <el-button
              @click="g_copyText(scope.row.requestId)"
              slot="append"
              icon="el-icon-document-copy"
            ></el-button>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="80px" label="再送">
        <template slot-scope="scope">
          <el-button
            @click="resendConversionEvent(scope.row)"
            type="primary"
            size="mini"
            >再送</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "smartnews-conversion-api-history-list",
  components: {},
  props: {
    conversionApiHistoryList: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool", "apiErrorMessage", "tools", "aspNames"]),
  },
  watch: {},
  methods: {
    getEventLabel(eventName) {
      // 「日本語名（送信する値）」。 マスタに無い値（想定外）は送信した値だけを出す
      const smartnewsEventData = this.$store.getters["tools02/smartnewsEventDataByEvent"](eventName);
      let eventLabel = eventName;
      if (smartnewsEventData !== undefined) {
        eventLabel = `${smartnewsEventData.name}（${eventName}）`;
      } else {
        // no action.
      }
      return eventLabel;
    },
    getErrorCode(apiHistoryData) {
      // HTTP ステータスと応答の error.issue を並べる（例: 400 Authentication failed）。 成功した送信は「-」
      let errorCode = "-";
      if (apiHistoryData.eventReceived === true) {
        // no action.
      } else {
        const httpStatus = [null, undefined].includes(apiHistoryData.httpStatus) ? "" : String(apiHistoryData.httpStatus);
        const errorIssue = [null, undefined].includes(apiHistoryData.errorIssue) ? "" : apiHistoryData.errorIssue;
        errorCode = `${httpStatus} ${errorIssue}`.trim();
        if (errorCode === "") {
          errorCode = "-";
        } else {
          // no action.
        }
      }
      return errorCode;
    },
    resendConversionEvent(apiHistoryData) {
      console.log(apiHistoryData);

      //
      const promotionName =
        apiHistoryData.reportData.tools02PromotionData !== null
          ? apiHistoryData.reportData.tools02PromotionData.promotionName
          : "-";

      //
      let confirmText = "";
      confirmText += `API送信日時: ${apiHistoryData.sendDatetime}\n`;
      confirmText += `プログラム名: ${promotionName}\n`;
      confirmText += `ピクセル名: ${apiHistoryData.tools02TagData.name}\n`;
      confirmText += `ピクセルタグID: ${apiHistoryData.pixelTagId}\n`;
      confirmText += `ビジネスID: ${apiHistoryData.businessId}\n`;
      confirmText += `CV発生日時: ${apiHistoryData.eventDatetime}\n`;
      confirmText += `報酬額: ${apiHistoryData.value}\n`;
      confirmText += `atid: ${apiHistoryData.adtasukaruId}\n`;
      confirmText += `\n`;
      confirmText += `のAPIを再送信します。よろしいですか？`;

      //
      let payload = {
        confirmText: confirmText,
        apiHistoryData: apiHistoryData,
      };
      this.$emit("resendConversionEvent", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
